export default __webpack_public_path__ + "static/media/favicon.29151987.ico";